export async function borlabsCookieA11yFixes() {
    if ('BorlabsCookie' in window) {
        const { initBorlabsCookieA11yFixes } = await import(/* webpackMode: "lazy" */ './inc/borlabs-cookies.async');

        initBorlabsCookieA11yFixes();
    }
}
